import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import {
  getCoursesSuccess,
  getCoursesFailure,
  getSingleCoursesSuccess,
  getSingleCoursesFailure,
} from "../slice/courseSlice";
const url = process.env.REACT_APP_API_URL;
// const url =" http://localhost:6002"

function* getSingleCoursesRequest(action) {
  try {
    const response = yield call(() =>
      axios.get(`${url}/courseDetails?courseId=${action.payload}`)
    );
    yield put(getSingleCoursesSuccess(response.data.data));
  } catch (error) {
    yield put(getSingleCoursesFailure(error.message));
  }
}

function* getCoursesRequest(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${url}/getAllCourse?page=${action.payload.page}&limit&sort=${action.payload.sort}&search=${action.payload.search}`
      )
    );
    yield put(getCoursesSuccess(response.data.data));
  } catch (error) {
    yield put(getCoursesFailure(error.message));
  }
}

export function* watchGetSingleCourses() {
  yield takeLatest("course/getSingleCourses", getSingleCoursesRequest);
}
export function* watchGetCourses() {
  yield takeLatest("course/getCourses", getCoursesRequest);
}
